<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" search v-if="false">
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="12" md="10" class="pa-0">
                  <v-text-field
                      :label="i18n.search"
                      filled
                      small
                      hide-details
                      dense
                      :class="`${arabic?'arFont':'enFont'}`"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-0">
                  <v-btn color="primary" text x-large block :class="`${arabic?'arFont':'enFont'}`">
                    {{i18n.search}}
                  </v-btn>
                </v-col>
              </v-row>
              
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" Headers>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.subject}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.date}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.new}}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3" v-for="(n, i) in notifications" :key="'notification-'+i"  style="cursor:pointer;" @click="openNotification(n)">
                <v-col cols="6" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{n.subject}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{getFormat(n.timestamp)}}</span>
                    </template>
                    <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                      {{new Date(n.timestamp)}}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`" >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" v-if="n.view" color="success">done_all</v-icon>
                      <v-icon v-bind="attrs" v-on="on" v-else-if="!n.view" color="success" size="12">circle</v-icon>
                    </template>
                    <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                      {{n.view}}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <v-dialog v-model="dialog" max-width="400">
        <v-card>
          <v-card-text v-if="dnotification">
            <v-row class="row pt-4">
              <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`" style="font-size:16px;">
                {{dnotification.subject}}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.native="()=>{dialog = false;dnotification=null}" :class="`${arabic?'arFont':'enFont'}`">
              {{i18n.close}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>

  
</template>

<script>
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';

export default {
  data() {
    return {
      loading:false,
      dialog:false,
      dnotification:null,
    }
  },
  
  methods: {
    getFormat(d){
      return format(d)
    },
    openNotification(n){
      this.dialog = true
      this.dnotification = n
      this.readNotification(n)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async loadFile(file, type, ext){
      console.log(file)
      var metadata = {
        contentType: type
      };
      this.uploadProgress = 0
      let ufile = file.name
      setInterval(x=>{this.uploadProgress+=5}, 250)
      await sleep(5050)
      this[this.uploadTo].documents.push({url:ufile, type:''})
      this.uploadProgress = 0
      this.uploading = false
    },
    onFilePicked (e) {
      this.uploading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        
      }
    },
    genKey(type){
      let a = `MCIT_${type}_${randomString(12, 'aA#')}`
      return a
    },
    pushNotification(){
      let t = []
      let v = getRandomInt(0,10)
      let n = {
        subject:`تقرير ${getRandomInt( 1, 12 )}/2020`,
        timestamp: new Date().getTime() - getRandomInt(0,6)*60*60*1000,
        view: v > 10 ? true : false,
        key:this.genKey('N'),
      }
      this.$store.state.notifications.push(n)
    },
    async readNotification(n){
      n.view = true
      this.loading = true
      await this.$store.dispatch('markAsRead', n)
      this.loading = false
    }
  },
  watch:{
  },
  computed:{
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    goalModel(){
      return this.$store.state.goalModel
    },
    keyResultModel(){
      return this.$store.state.keyResultModel
    },
    initModel(){
      return this.$store.state.initiativeModel
    },
    units(){
      return this.$store.state.units
    },
    quarters(){
      return this.$store.state.quarters
    },
    fileTypes(){
      return this.$store.state.fileTypes
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.loading = true
    await this.$store.dispatch('getNotifications')
    this.loading = false
  },
  
}
</script>

<style>
.vline {
  max-width: 1px;
  min-height: 19px;
  background: #c2c2c2;
  position: relative;
  top: -19px;
}
.vdesc {
  position: relative;
  top: -36px;
  max-width: 30px;
  font-size: 10px;
  max-height: 0;
  white-space: nowrap;
}
</style>